import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationService } from '../shared/services/index';

@Pipe({
    name: 'reportType',
    standalone: false
})
export class ReportTypePipe implements PipeTransform {
  constructor(private service: ApplicationService) {}

  transform(value: number): any {
    return this.service.getValue(value);
  }
}
